/* eslint-disable @typescript-eslint/no-unused-vars */
import { Inject, Injectable } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { map, withLatestFrom } from 'rxjs/operators';

import { LocalizationGrpcContractService } from '../../api/grpc';
import { ErrorService } from '../../services/error.service';
import { SSRService } from '../../services/ssr.service';
import * as actions from '../actions/languages.actions';
import { LanguagesSelectService } from '../selectors/languages.selector';
import { IAppState } from '../states/app.state';

@Injectable()
export class LanguagesEffects {
  // getLang$ = createEffect(() =>
  //   this._actions$.pipe(
  //     ofType(actions.GET_LANG_COMMAND),
  //     mergeMap(() =>
  //       this._localizationGrpcContractService.getLanguages().pipe(
  //         map(({ Languages }) =>
  //           actions.GET_LANG_SUCCESS({
  //             languages: Languages!,
  //           }),
  //         ),
  //         catchError((response) => this._errorService.handleApiError(response)),
  //       ),
  //     ),
  //   ),
  // );

  setLang$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(actions.SET_LANG),
        withLatestFrom(this._languagesSelect.getLanguages(), this._languagesSelect.getLocalizations()),
        map(([{ language }, langs, localizations]) => {
          // if (langs.length === 0) {
          //   this._store$.dispatch(actions.GET_LANG_COMMAND());
          // }
          // if (this._language !== language || localizations.length === 0) {
          //   this._store$.dispatch(actions.GET_LACALIZATION_COMMAND());
          // }
          if (language) {
            this._locale = language;
          }
          moment.locale(language!);
          this._adapter.setLocale(language);
          this._adapter.getFirstDayOfWeek = () => {
            return 1;
          };
        }),
      ),
    { dispatch: false },
  );

  // getLocalization$ = createEffect(() =>
  //   this._actions$.pipe(
  //     ofType(actions.GET_LACALIZATION_COMMAND),
  //     mergeMap(() =>
  //       this._localizationGrpcContractService.getLocalization().pipe(
  //         tap(({ Items }) => {
  //           if (isDevMode() && Items) {
  //             const labels = Object.values(LabelType);
  //             const notFilledConstants = labels.filter(
  //               (x) => !Items.some((l) => l.Key?.toLocaleLowerCase() === x.toLocaleLowerCase()),
  //             );
  //             if (notFilledConstants.length > 0) {
  //               console.log('Not filled constants:', notFilledConstants);
  //             }
  //           }
  //         }),
  //         map(({ Items }) =>
  //           actions.GET_LACALIZATION_SUCCESS({
  //             items: Items!,
  //           }),
  //         ),
  //         catchError((response) => this._errorService.handleApiError(response)),
  //       ),
  //     ),
  //   ),
  // );

  private _language?: string;
  private _isBrowser: boolean = false;

  constructor(
    private _store$: Store<IAppState>,
    private _actions$: Actions,
    private _languagesSelect: LanguagesSelectService,
    private _localizationGrpcContractService: LocalizationGrpcContractService,
    private _errorService: ErrorService,
    private _ssrService: SSRService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
  ) {}
}
